import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Administrator, blockout_availability, BookingOfficer, Interpreter, UserFactory} from '../../shared/model/user.entity';
import { AvailabilityBlock } from '../../shared/model/availability-block.entity';
import { GLOBAL } from '../../shared/global';
import {  MdDialogRef } from '@angular/material';
import { CalendarComponent } from 'ap-angular2-fullcalendar';
import * as moment from 'moment';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { UserService } from '../../api/user.service';
import { dashCaseToCamelCase } from '@angular/compiler/src/util';
import { Booking } from '../../shared/model/booking.entity';
import * as momentTimeZone from 'moment-timezone';
import { SpinnerService } from '../../spinner/spinner.service';


@Component({
    selector: 'app-staff-calendar',
    templateUrl: './staff-calendar.component.html',
    styleUrls: ['./staff-calendar.component.css']
})
export class StaffCalendarComponent implements OnInit {
    userModel: Interpreter;
    @ViewChild('mycal') myCal: CalendarComponent;
    displayCalendar = true;
    calendarOptions: Object = {};
    updateCalendar = false;
    userID;
    interpreter: Interpreter;
    constructor(public spinnerService: SpinnerService,
         public routes: ActivatedRoute, public userDataService: UserService, private route: ActivatedRoute, private router: Router) {
        this.userModel = new Interpreter();
    }
    isUserLogin() {
        return Boolean(GLOBAL.currentUser);
    }

    ngOnInit() {
        let d = new DatePipe('en-us');
        this.userModel.naati_validity_start_date = Boolean(this.userModel.naati_validity_start_date) ?
            d.transform(this.userModel.naati_validity_start_date.trim().replace(' ', '0'), 'yyyy-MM-dd') :
            this.userModel.naati_validity_start_date;
        this.userModel.naati_validity_end_date = Boolean(this.userModel.naati_validity_end_date) ?
            d.transform(this.userModel.naati_validity_end_date.trim().replace(' ', '0'), 'yyyy-MM-dd') :
            this.userModel.naati_validity_end_date;
        this.userModel.date_of_birth = Boolean(this.userModel.date_of_birth) ?
            d.transform(this.userModel.date_of_birth.trim().replace(' ', '0'), 'yyyy-MM-dd') :
            this.userModel.date_of_birth;

        delete this.userModel.assignments_attributes;
        delete this.userModel.password;
        this.spinnerService.requestInProcess(true);
        this.routes.params.subscribe(params => {
             this.userID = +params['id'] || false;
             if (this.userID) {
                localStorage.setItem('userId', this.userID);
                this.userDataService.getUser(this.userID)
                    .subscribe((res: any) => {
                        if (res.status === 200) {
                            delete res.data.assignments_attributes;
                            this.interpreter = res.data;
                            this.userModel.staff_availabilities_attributes = res.data.staff_availabilities_attributes;
                            this.StaffAvialabilityToUpdate();
                        }
                        this.spinnerService.requestInProcess(false);
                    });
            }
         });
    }

    isUserAdminOrBO() {
        return GLOBAL.currentUser instanceof Administrator ||
            GLOBAL.currentUser instanceof BookingOfficer;
    }
    getStaffAvailabilities(userID) {
    }
    StaffAvialabilityToUpdate() {
        if (this.displayCalendar) {
            this.calendarOptions = {
                height: 'auto',
                fixedWeekCount: false,
                weekends: true, // will hide Saturdays and Sundays
                slotDuration: '01:00:00',
                header: {
                    left: 'title',
                    center: '',
                    right: $(window).width() >= 768 ? 'month,agendaWeek,agendaDay,listYear,today,prev,next' : 'today,prev,next'
                },
                textColor: '#ffffff',
                contentHeight: 'auto',
                navLinks: true, // can click day/week names to navigate views
                selectable: true,
                selectHelper: true,
                windowResize: (view) => {
                    this.myCal.fullCalendar('changeView', $(window).width() < 768 ? 'listMonth' : 'month');
                },
                // customize the button names,
                // otherwise they'd all just say "list"
                views: {

                    month: { buttonText: 'month' }
                },
                eventRender: function (event, elm, view) {
                    return event.recurring === false || (event.ranges.filter(function (range) { // test event against all the ranges
                        event.end = event.end || event.start;
                        return (event.start.isBefore(range.end) &&
                            event.end.isAfter(range.start));

                    }).length) > 0; // if it isn't in one of the ranges, don't render it (by returning false
                },
                defaultView: $(window).width() < 768 ? 'listMonth' : 'month',
                eventClick: (calEvent, jsEvent, view) => {
                        this.router.navigate(['/user-management/', calEvent.id, 'staff-availability']);
                },
                editable: true,
                eventLimit: 2, // allow "more" link when too many events
                events: []
            };
            for (let avail_block of this.userModel.staff_availabilities_attributes) {
                let startDate;
                startDate = this.interpreterStateDateZone(avail_block.start_time);
                startDate = new Date(startDate);
                let endDate;
                if (!avail_block.recurring) {
                    endDate = this.interpreterStateDateZone(avail_block.start_time);
                } else {
                    endDate = this.interpreterStateDateZone((avail_block.end_date || avail_block.start_time));
                }
                endDate = new Date(endDate);
                let startTime = this.interpreterStateTimeZone(avail_block.start_time);

                let endTime = this.interpreterStateTimeZone(avail_block.end_time);

                let eventStart = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(),
                    moment.duration(startTime).get('hours'), moment.duration(startTime).get('minutes'));

                let eventEnd = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(),
                    moment.duration(endTime).get('hours'), moment.duration(endTime).get('minutes'));

                let event: any = ({
                    title: avail_block.name,
                    color: avail_block.booking_id ? '#3bb69c' : '#02b86e',
                    id: avail_block.id,
                    textColor: '#ffffff',
                    booking_id: avail_block.booking_id,
                    start: avail_block.recurring === false ? eventStart : ('' + moment.duration(startTime).get('hours') +
                        ':' + moment.duration(startTime).get('minutes') + ':00'),
                    end: avail_block.recurring === false ? eventEnd : ('' + moment.duration(endTime).get('hours') +
                        ':' + moment.duration(endTime).get('minutes') + ':00'),
                    recurring: avail_block.recurring,
                    frequency: avail_block.frequency
                });
                if (avail_block.recurring === true) {
                    event.dow = avail_block.frequency === 'daily' ? [0, 1, 2, 3, 4, 5, 6] : this.setDays(avail_block.recurring_week_days);
                    event.ranges = [
                        {
                            start: moment().endOf(avail_block.frequency === 'daily' ? 'day' :
                                avail_block.frequency === 'weekly' ? 'week' :
                                    avail_block.frequency === 'monthly' ? 'month' : 'week'),
                            end: moment().endOf(avail_block.frequency === 'daily' ? 'day' :
                                avail_block.frequency === 'weekly' ? 'week' :
                                    avail_block.frequency === 'monthly' ? 'month' : 'week')
                        }, {
                            start:  eventStart,
                            end:  endDate
                        }
                    ];
                }
                this.calendarOptions['events'].push(event);
            }
            this.updateCalendar = true;
        }

    }
    setDays(days) {
        let data = [];
        days.forEach(element => {
            data.push(+element);
        });
        return data;
    }
    interpreterStateTimeZone(time) {
        let timeZone = Booking.getNamedTimeZone(this.interpreter.address_attributes.state, this.interpreter.address_attributes.post_code.toString());
        return momentTimeZone(time).tz(timeZone).format('HH:mm:ss');
    }
    interpreterStateDateZone(datetime) {
        let timeZone = Booking.getNamedTimeZone(this.interpreter.address_attributes.state, this.interpreter.address_attributes.post_code.toString());
        return momentTimeZone(datetime).tz(timeZone).format();
    }
}



// WEBPACK FOOTER //
// ./src/app/user-management/staff-calendar/staff-calendar.component.ts